













import { Component, Prop, Vue } from 'vue-property-decorator';
import { ShoppingCartItemDto } from '@/api';
import { getModule } from 'vuex-module-decorators';
import KeycloakStore from '@/stores/user/keycloak.store';

@Component({
  components: {
  },
})
export default class ProductDetailCartSection extends Vue {
  private keycloakStore = getModule(KeycloakStore, this.$store);

  @Prop({required: true})
  public localItem!: ShoppingCartItemDto;

  @Prop({required: true})
  public hasOfferPrice!: boolean;

  @Prop({required: false})
  public listPriceString?: string;

  @Prop({required: false})
  public effectivePriceString?: string;

}
